<template>
    <VContainer >
        <VLayout wrap>
            <v-flex xs12 m7>
                <v-card class="elevation-1">
                    <v-card-title class="justify-space-between title font-weight-light">
                        Payment Methods
                        <v-spacer></v-spacer>
                        <v-btn icon class="ma-0" @click="cancel()">
                            <v-icon>fas fa-arrow-circle-left</v-icon>
                        </v-btn>
                    </v-card-title>

                    <v-card-text v-if="this.$store.state.customer===false">
                        <p>Step 1: Enter payment method</p>
                    </v-card-text>

                    <v-card-text v-if="$store.state.customer===undefined">
                        <h3>Fetching Payment Data</h3>
                        <v-progress-linear indeterminate></v-progress-linear>
                    </v-card-text>

                    <v-card-text  v-else-if="$store.state.customer===false">
                        <h3>Enter Payment Method</h3>
                        <p>
                            <span class="title">{{errormessage}}</span>
                        </p>
                        <div class="stripe-card">
                            <Card   :class='{ complete } '
                                    ref="addcustomer"
                                    v-if="stripepublickey"
                                    :stripe='stripepublickey'
                                    :options='stripeOptions'
                                    @change='complete = $event.complete'
                            ></Card>
                        </div>
                        <BaseBtn v-if="$store.state.appdata"  dark
                               class='pay-with-stripe mt-2'
                               @click='createcustomer()'
                               :disabled='!complete'
                               :loading="creatingcustomer">
                            Next
                            <v-icon class="ml-2">fas fa-arrow-circle-right</v-icon>
                        </BaseBtn>
                    </v-card-text>

                    <v-card-text v-else>
                        <v-list two-line v-if="defaultsource">
                            <v-list-item v-for="s in defaultsource" :key="s.id">
                                <v-list-item-avatar tile>
                                    <v-list-item-avatar tile size="40" >
                                        <img :src="require(`@/assets/ccards/${s.brand.toLowerCase()}.png`)" />
                                    </v-list-item-avatar>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        DEFAULT CARD:
                                        Exp {{s.exp_month}}/{{s.exp_year}}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Ending in {{s.last4}} {{s.brand}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                        <v-divider></v-divider>
                        <span class="justify-space-between title font-weight-light">Cards</span>
                        <v-list two-line>
                            <v-list-item v-for="s in stripecustomer.sources.data" :key="s.id" @click="">
                                <v-list-item-avatar tile >
                                    <v-list-item-avatar tile size="40" >
                                        <img :src="require(`@/assets/ccards/${s.brand.toLowerCase()}.png`)" />
                                    </v-list-item-avatar>
                                </v-list-item-avatar>
                                <v-list-item-content @click="getCard(s.id)">
                                    <v-list-item-title>
                                        Exp {{s.exp_month}}/{{s.exp_year}}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Ending in {{s.last4}} {{s.brand}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action v-if="changingdefault" @click="changeDefault(s.id)">
                                    <v-btn small icon color="success"><v-icon>{{$store.state.icons.plus}}</v-icon></v-btn>
                                </v-list-item-action>
                                <v-list-item-action v-if="removingcard" @click="removeCard(s.id)">
                                    <v-btn small icon color="warning" ><v-icon>{{$store.state.icons.minus}}</v-icon></v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </v-card-text>

                    <v-card-actions>
                        <BaseBtn  @click="$router.history.go(-1)">
                            <v-icon>fas fa-arrow-circle-left</v-icon>
                            <span class="hidden-xs-only">Back</span>
                        </BaseBtn>
                        <v-spacer></v-spacer>
                        <BaseBtn  @click="addcarddialog=true" :disabled="!$store.state.customer">Add</BaseBtn>
                        <v-spacer></v-spacer>
                        <BaseBtn  @click="changingdefault=!changingdefault,removingcard=false" :disabled="!$store.state.customer || !$store.state.customer.sources[0]">
                            <span v-if="!changingdefault">Default</span>
                            <span v-if="changingdefault">Done</span>
                        </BaseBtn>
                        <v-spacer></v-spacer>
                        <BaseBtn  @click="removingcard=!removingcard,changingdefault=false" :disabled="!$store.state.customer || !$store.state.customer.sources[0]">
                            <span v-if="!removingcard">Remove</span>
                            <span v-if="removingcard">Done</span>
                        </BaseBtn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </VLayout>


        <!--ADD CARD DIALOG-->
        <v-dialog v-model="addcarddialog" persistent fullscreen>
            <v-card>
                <v-card-title class="justify-space-between title font-weight-light">
                    Add Payment Method
                </v-card-title>
                <v-card-text>
                    <h3>Add Payment Method</h3>
                    <span class="title red--text">{{errormessage}}</span>
                    <div class="stripe-card">
                        <Card   :class='{ complete } '
                                ref="addcard"
                                v-if="stripepublickey"
                                :stripe='stripepublickey'
                                :options='stripeOptions'
                                @change='complete = $event.complete'
                        ></Card>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <BaseBtn  @click="addcarddialog=false,$refs.addcard.clear()">
                        Cancel
                    </BaseBtn>
                    <v-spacer></v-spacer>
                    <v-btn class='pay-with-stripe outline white--text'
                           :loading="loading"
                           color="indigo darken-1"
                           @click='addcard()'
                           :disabled='!complete'>
                        Add Card
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!--DEFAULT PAYMENT METHOD DIALOG-->
        <v-dialog v-model="changingfaultdialog" persistent>
            <v-card>
                <v-card-title class="justify-space-between font-weight-light">
                    Default Payment Method
                </v-card-title>
                <v-card-text>
                    <h2 class="font-weight-light">
                        Set as new default:
                    </h2>
                    <v-list-item v-if="newdefault">
                        <v-list-item-avatar tile>
                            <v-icon color="green">
                                fab fa-cc-{{newdefault.brand.toLowerCase()}}
                            </v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>
                                Exp {{newdefault.exp_month}}/{{newdefault.exp_year}}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                Ending in {{newdefault.last4}} {{newdefault.brand}}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <h2 class="font-weight-light">
                        Remove as default:
                    </h2>
                    <v-list-item v-if="olddefault">
                        <v-list-item-avatar tile>
                            <v-list-item-avatar tile size="40" >
                                <img :src="require(`@/assets/ccards/${s.brand.toLowerCase()}.png`)" />
                            </v-list-item-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>
                                Exp {{olddefault.exp_month}}/{{olddefault.exp_year}}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                Ending in {{olddefault.last4}} {{olddefault.brand}}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                </v-card-text>
                <v-card-actions>
                    <BaseBtn @click="changingfaultdialog=false,changingdefault=false">Cancel</BaseBtn>
                    <v-spacer></v-spacer>
                    <BaseBtn @click="confirmChangeDefault()" :loading="loading">
                        Confirm
                    </BaseBtn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!--REMOVE CARD DIALOG-->
        <v-dialog v-model="removecarddialog" persistent>
            <v-card>
                <v-card-title>
                    Remove Payment Method
                </v-card-title>
                <v-card-text>
                    Remove payment method
                    <v-list-item v-if="removecard">
                        <v-list-item-avatar tile>
                            <v-list-item-avatar tile size="40" >
                                <img :src="require(`@/assets/ccards/${s.brand.toLowerCase()}.png`)" />
                            </v-list-item-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>
                                Exp {{removecard.exp_month}}/{{removecard.exp_year}}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                Ending in {{removecard.last4}} {{removecard.brand}}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-card-text>
                <v-card-actions>
                    <BaseBtn @click="removecarddialog=false,removingcard=false">Cancel</BaseBtn>
                    <v-spacer></v-spacer>
                    <BaseBtn @click="confirmRemovePaymentMethod()" :loading="loading">Confirm</BaseBtn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </VContainer>
</template>

<script>
  import {Card, createToken} from 'vue-stripe-elements-plus'
  import BaseBtn from "../BaseBtn";

  export default {
    components: {BaseBtn, Card},
    name: "PaymentMethods",
    data() {
      return {
        /*Options for STRIPE ELEMENTS*/
        stripepublickey: false,
        stripeOptions: {},
        complete: false,
        /*Options for products and pricing*/
        selectedsku: false,
        selectedpricing: false,
        selectedpricingname: '',
        selectedathletes: false,
        //stripecustomer:undefined,
        step: 1,
        loading: false,
        myathletes: [],
        session: false,
        newathletedialog: false,
        registrants: [],
        settingcheckout: false,
        custId: false, //get from our records or create in Stripe
        appdata: false,
        creatingcustomer: false,
        orderitems: [],
        ordering: false,
        myorders: [],
        teamname: '',
        errormessage: '',
        mykey: '',
        month: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        disablechecks: false,
        selectedsource: false,
        addcarddialog: false,
        changingdefault: false,
        changingfaultdialog: false,
        olddefault: false,
        newdefault: false,
        removingcard: false,
        removecarddialog: false,
        removecard: false,
        subscriptions: false,
        plans: false
      }
    },
    computed: {
      defaultsource() {
        if (!this.$store.state.customer) return false;
        return this.$store.state.customer.sources.data.filter(f => {
          return f.id === this.stripecustomer.default_source
        })
      },
      stripecustomer() {
        return this.$store.state.customer
      }
    },
    watch: {
      skus: function () {
        if (this.skus.length === 1) {
          this.selectedsku = this.skus[0].id;
        }
      },
      selectedsource: function (n, o) {
        let em = this;
        console.log(n, o)
      }
    },
    async mounted() {
      let em = this;
      this.getStripePublicKey()
    },
    methods: {
      async createcustomer() {
        //todo - diff stripe live vs test tokens in appdata
        //will create customer if needed, then add a card.
        let em = this;
        em.creatingcustomer = true;
        let token = await createToken().then(data => {
          if (data.error) {
            em.creatingcustomer = false;
            em.errormessage = data.error.message;
            em.complete = false;
            return false;
          } else {
            em.complete = true;
            return data.token.id;
          }
        })
        if (!token) {
          em.creatingcustomer = false;
          em.complete = false;
          return;
        }
        em.$refs.addcustomer.clear()
        let data = {
          stripeToken: token,
          email: em.$store.state.cognito.user.attributes.email,
          metadata: em.$store.state.cognito.user.attributes
        }
        let args = {
          url: this.$store.state.url + 'api/payments/stripegeneralusers/customer',
          method: 'POST',
          data: data
        }
        this.$store.dispatch('fetch', args)
            .then(function (response) { console.log(response)
              em.creatingcustomer = false;
              let customer = response.customer;
              let appdata = response.appdata;
              if (customer && customer.type === 'StripeCardError') {
                em.failed(customer)
              } else {
                if (customer && customer.id) {
                  console.log(customer)
                  em.$store.commit('setCustomer', customer)
                  // wait for aws to set
                  // the stripe id into our appdata
                  if(appdata){
                    em.$store.commit('setAppdata',appdata)
                  }
                }
              }
            }).catch(function (e) {
          em.creatingcustomer = false;
          console.log(e)
        })
      },
      async addcard() { //will create customer if needed, then add a card.
        let em = this;
        let token = await createToken().then(data => {
          if (data.error) {
            em.creatingcustomer = false;
            em.errormessage = data.error.message;
            em.complete = false;
            return false;
          } else {
            return data.token.id;
          }
        })
        if (!token) {
          em.creatingcustomer = false;
          em.complete = false;
          return;
        }
        em.loading = true;
        em.$refs.addcard.clear()
        let data = {
          stripeToken: token,
          custId: this.$store.state.appdata.stripe,
        }
        let args = {
          url: this.$store.state.url + 'api/payments/stripegeneralusers/createsource',
          method: 'POST',
          data: data
        };
        this.$store.dispatch('fetch', args)
            .then(function (response) {
              console.log(response)
              if (response.error) {
                em.failed(response)
              }
              if (response.type === 'StripeCardError') {
                em.failed(response)
              } else {
                if (response.id) {
                  em.addcarddialog = false
                  em.key = new Date().getTime()
                  em.$store.dispatch('getCustomer')
                }
                em.creatingcustomer = false;
                em.loading = false
              }
            }).catch(function (e) {
          setTimeout(function () {
            em.$store.dispatch('getCustomer');
            em.loading = false
          }, 2200)
          console.log(e)
        })
      },
      async getCard(id) {
        let args = {
          url: this.$store.state.url + 'api/payments/stripegeneralusers/card/' + id,
          method: 'GET'
        };
        this.$store.dispatch('fetch', args)
            .then(function (response) {
              console.log(response)
            }).catch(function (e) {
          console.log(e)
        })
      },
      async pay() {
        // createToken returns a Promise which resolves in a result object with
        // either a token or an error key.
        // See https://stripe.com/docs/api#tokens for the token object.
        // See https://stripe.com/docs/api#errors for the error object.
        // More general https://stripe.com/docs/stripe.js#stripe-create-token.
        let em = this;
        let token = await createToken().then(data => {
          console.log("stripe data: ", data);
          return data.token;
        })
        console.log("token");
        let headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'orgkey': em.$store.state.orgkey
        };
        let data = {
          orgkey: em.$store.state.orgkey,
          stripeToken: token,
          stripeEmail: 'jenny.rosen@example.com',
          sku: 'sku1324'
        }
        let args = {
          headers: headers,
          method: 'post',
          body: JSON.stringify(data)
        };
        fetch(this.apiendpoint + 'api/payments/stripe/createandcharge', args)
            .then((response) => response.json())
            .then((response) => {
              console.log(response)
            })
      },
      stripePricing() {
        let em = this;
        this.skus.forEach(function (s) {
          console.log("Skus Iteration: ", s)
          if (em.selectedsku === s.id) {
            em.selectedpricing = s
            em.selectedpricingname = s.attributes.name
          }
        })
      },
      goToCheckout() {
        let em = this;
        em.settingcheckout = true
        setTimeout(function () {
          em.step = 4
          em.settingcheckout = false
        }, 832)
      },
      createOrder() { //THIS IS THE ACTUAL PAY FUNCTION
        if (!this.stripecustomer) return;
        let em = this;
        em.ordering = true;
        let headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Pool': em.$store.state.cognito.user.pool.userPoolId,
          'Authorization': 'Bearer ' + em.$store.state.cognito.session.accessToken.jwtToken,
          'orgkey': em.$store.state.orgkey
        };
        let data = {
          custId: this.stripecustomer.id,
          items: this.orderitems,
          event: this.activeevent,
          participants: this.selectedathletes,
          teamname: this.teamname,
          source: this.defaultsource.id
        }
        let args = {
          headers: headers,
          method: 'post',
          body: JSON.stringify(data)
        };
        fetch(this.apiendpoint + 'api/payments/stripe/createorder', args)
            .then((response) => response.json())
            .then((response) => {
              console.log(response)
              em.ordering = false;
              em.step = 6
            }).catch(e => {
          em.ordering = false;
          console.log(e)
        })
      },
      myOrders() {
        let em = this;
        let headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Pool': em.$store.state.cognito.user.pool.userPoolId,
          'Authorization': 'Bearer ' + em.$store.state.cognito.session.accessToken.jwtToken,
          'orgkey': em.$store.state.orgkey
        };
        let args = {
          headers: headers,
          method: 'get'
        };
        fetch(this.$store.state.url + 'api/payments/stripe/customerorderssql/' + this.custId, args)
            .then((response) => response.json())
            .then((response) => {
              console.log(response)
              em.myorders = response
            })
      },
      getStripePublicKey() {
        this.stripepublickey = this.$store.state.stripeClient;
      },
      failed(response) {
        let em = this;
        em.errormessage = '';
        em.creatingcustomer = false;
        em.errormessage = response.message;
        em.complete = false;
        em.loading = false;
        return false;
      },
      changeDefault(id) {
        this.newdefault = this.stripecustomer.sources.data.filter(f => {
          return f.id === id
        })[0]
        this.olddefault = this.stripecustomer.sources.data.filter(f => {
          return f.id === this.stripecustomer.default_source
        })[0]
        this.changingfaultdialog = true
      },
      confirmChangeDefault() {
        let em = this;
        em.loading = true;
        let data = {
          cardId: em.newdefault.id,
          custId: em.$store.state.customer.id
        }
        let args = {
          url: this.$store.state.url + 'api/payments/stripegeneralusers/customerdefaultsource',
          method: 'PUT',
          data: data
        };
        this.$store.dispatch('fetch', args)
            .then(function (response) {
              if (response.type === 'StripeCardError') {
                em.failed(response)
              } else {
                if (response.id) {
                  em.$store.dispatch('getCustomer')
                }
              }
              em.loading = false
              em.changingfaultdialog = false
              em.changingdefault = false
            }).catch(function (e) {
          em.loading = false
        })
      },
      removeCard(id) {
        this.removecard = this.stripecustomer.sources.data.filter(f => {
          return f.id === id
        })[0]
        this.removecarddialog = true
      },
      confirmRemovePaymentMethod() {
        let em = this;
        em.loading = true;
        let data = {
          cardId: em.removecard.id
        }
        let args = {
          url: this.$store.state.url + 'api/payments/stripegeneralusers/card',
          method: 'DELETE',
          data: data
        };
        this.$store.dispatch('fetch', args)
            .then(function (response) {
              console.log(response)
              if (response.type === 'StripeCardError') {
                em.failed(response)
              } else {
                if (response.id) {
                  em.$store.dispatch('getCustomer')
                }
              }
              em.loading = false
              em.removecarddialog = false
              em.removingcard = false
            }).catch(function (e) {
          em.$store.dispatch('getCustomer')
          console.log(e)
        })
      },
      cancel() {
        this.$router.history.go(-1)
      }
    }
  }
</script>

<style scoped>
    .outline{
        border: solid thin lightgray;
        border-radius:5px;
    }
    .stripe-card {
        width: 320px;
        border: 1px solid grey;
        border-radius: 3px;
        padding:10px;
    }
    .stripe-card .complete {
        border-color: green;
    }
    .faded{
        background-color: rgba(50,50,50,.5);
    }
    a{
        text-decoration: none;
    }
</style>